import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pass-word-changer',
  templateUrl: './pass-word-changer.component.html',
  styleUrls: ['./pass-word-changer.component.scss']
})
export class PassWordChangerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
